<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
			交易管理>支付设置
		</div>
		<div>
			<el-dialog title="设置密钥" :visible.sync="editShow" width="30%" @close="paySettingClear()">
				<el-form label-width="120px">
					<el-form-item label="微信支付MID">
						<el-input v-model="edit.mchId" type="text"></el-input>
					</el-form-item>
					<el-form-item label="微信支付秘钥">
						<el-input v-model="edit.payKey" type="text"></el-input>
					</el-form-item>
					<el-form-item label="美团店铺店铺ID">
						<el-input v-model="edit.openShopUuid" type="text"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="editShow=false">取 消</el-button>
					<el-button type="primary" @click="editOrSave()">确 定</el-button>
				</span>
			</el-dialog>
		</div>
		<div class="title">
			<div class="left">
				<!-- <el-button type="primary" size="small" @click="editShow=true">添加门店</el-button> -->
			</div>
			<div class="right">
				<el-select filterable clearable v-model="query.city" style="width: 150px;margin-right: 20px;"
					size="small">
					<el-option v-for="item in city" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" placeholder="店铺名称" style="width: 200px;margin-right: 20px;" size="small"
					v-model="query.condition"></el-input>
				<el-button type="primary" size="small" @click="getPaySetting()">搜索</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="paySettings" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
				style="width: 100%">
				<el-table-column prop="id" align="center" label="ID" width="80">
				</el-table-column>
				<el-table-column label="门店名称" prop="title" align="center" width="150">
				</el-table-column>
				<el-table-column prop="mchId" align="center" label="微信支付MID">
				</el-table-column>
				<el-table-column prop="payKey" align="center" label="微信支付秘钥">
				</el-table-column>
				<el-table-column align="center" prop="openShopUuid" label="美团店铺店铺ID">
				</el-table-column>
				<el-table-column align="center" label="操作">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="editSetting(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="handleCurrentChange" style="margin-top: 30px;"
				layout="prev, pager, next" :page-size="10" :total="query.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				city: [],
				editShow: false,
				edit: {
					id: "",
					mchId: "",
					payKey: "",
					openShopUuid: "",
				},
				query: {
					page: 1,
					size: 10,
					total: 0,
					condition: "",
					city: "",
				},
				paySettings: [],
			};
		},
		mounted() {
			this.getcity()
			this.getPaySetting();
		},
		methods: {
			paySettingClear() {
				this.edit = {
					id: "",
					mchId: "",
					payKey: "",
					openShopUuid: "",
				};
			},
			editSetting(row) {
				this.editShow = true;
				this.edit.id = row.id;
				this.edit.mchId = row.mchId;
				this.edit.payKey = row.payKey;
				this.edit.openShopUuid = row.openShopUuid;
			},
			editOrSave() {
				this.$http.post("paySetting/edit", this.edit).then(res => {
					this.editShow = false;
					this.$message.success("修改成功")
					this.getPaySetting()
				}, resp => {
					this.$message.error("系统异常")
				})
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getPaySetting();
			},
			getcity() {
				const provinces = require('province-city-china/dist/city.json');
				this.city = []
				for (let i = 0; i < provinces.length; i++) {
					var a = {
						label: provinces[i].name,
						value: provinces[i].name
					}
					this.city.push(a)
				}
			},
			getPaySetting() {
				let query = "?page=" + this.query.page + "&size=" + this.query.size;
				if (this.query.condition) query += "&condition=" + this.query.condition
				if (this.query.city) query += "&city=" + this.query.city
				this.$http.get("paySetting/list" + query).then((res) => {
					this.paySettings = res.body.data.rows;
					this.query.total = res.body.data.total;
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}
</style>